import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {ReactComponent as EditIcon} from "../../../assets/icons/editPenIcon.svg";
import './MobileAlertRulesList.scss'

const selector = state => {
    const { language, alertRules, modalState } = state;
    return {
        t: language.translator,
        pending: alertRules.pending,
        alertRules: alertRules.alertRules,
        selected: alertRules.selected,
        alertMessages: alertRules.alertMessages,
        modalState: modalState
    }
};


const MobileAlertRulesList = props => {
    const {items, selectItemMethod, selected, editMethod} = props;
    const {t} = useSelector(selector)
    const dispatch = useDispatch();
    return (
        <div className='MobileAlertRulesListContainer'>
            {items && items.length > 0 && items.map(x => {
                return (
                    <div className="mobileAlertRulesListItem">
                        <div className="mAlertRulesListTitleContainer">
                            <div className="mAlertRulesListTitle">
                                {x.ruleName}
                            </div>
                            <div
                                onClick={() => editMethod(x)}
                                className="mAlertRulesListIconContainer">
                                <EditIcon/>
                            </div>
                        </div>
                        <table className="mAlertRulesListTable">
                            <thead>
                            <tr>
                                <th colSpan="2">{t.gettext('Item--name')}</th>
                                <th>{t.gettext('Value')}</th>
                                <th>{t.gettext('Unit')}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td rowSpan="2">{t.gettext('Lower threshold')}</td>
                                <td>{t.gettext('Critical Alert')}</td>
                                <td className="red">{
                                    (x?.thresholds?.find(y => y.warningType === 'ALARM_LOW')?.value !== undefined)
                                        ? String(x.thresholds.find(y => y.warningType === 'ALARM_LOW')?.value.toFixed(1) || 0)
                                        : '-'
                                }</td>
                                <td className="unit">{x.measurementTypeUnit}</td>
                            </tr>
                            <tr>
                                <td>{t.gettext('Standard Alert')}</td>
                                <td className="orange">{
                                    (x?.thresholds?.find(y => y.warningType === 'WARNING_LOW')?.value !== undefined)
                                        ? String(x.thresholds.find(y => y.warningType === 'WARNING_LOW')?.value.toFixed(1) || 0)
                                        : '-'
                                }</td>
                                <td className="unit">{x.measurementTypeUnit}</td>
                            </tr>
                            <tr>
                                <td rowSpan="2">{t.gettext('Upper threshold')}</td>
                                <td>{t.gettext('Standard Alert')}</td>
                                <td className="orange">{
                                    (x?.thresholds?.find(y => y.warningType === 'WARNING_HIGH')?.value !== undefined)
                                        ? String(x.thresholds.find(y => y.warningType === 'WARNING_HIGH')?.value.toFixed(1) || 0)
                                        : '-'
                                }</td>
                                <td className="unit">{x.measurementTypeUnit}</td>
                            </tr>
                            <tr>
                                <td>{t.gettext('Critical Alert')}</td>
                                <td className="red">{
                                    (x?.thresholds?.find(y => y.warningType === 'ALARM_HIGH')?.value !== undefined)
                                        ? String(x.thresholds.find(y => y.warningType === 'ALARM_HIGH')?.value.toFixed(1) || 0)
                                        : '-'
                                }</td>
                                <td className="unit">{x.measurementTypeUnit}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                )
            })}

        </div>
    )
}

export default MobileAlertRulesList
